import Common from "../../../Common";
import Dummy from "./queue/Dummy";

export type CompanyWallboardQueueCreateBody = CompanyWallboardQueueUpdateBody & {
	queue_id?: number
	queue_type: id | 'normal'
	wallboard_queue_id?: number
}

export interface CompanyWallboardQueueUpdateBody {
	position: number
	timeout: number
	hidden?: 1 | 0 | "1" | "0"
	x?: number
	y?: number
	width?: number
	height?: number
}

const Queue = class extends Common {
	dummy: InstanceType<typeof Dummy>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.dummy = new Dummy(headers);
	}

	create = (companyId: id, wallboardId: id, body: CompanyWallboardQueueCreateBody) =>
		this.post(`/company/${companyId}/wallboard/${wallboardId}/queue`, body)

	update = (companyId: id, wallboardId: id, id: id, body: CompanyWallboardQueueUpdateBody) =>
		this.patch(`/company/${companyId}/wallboard/${wallboardId}/queue/${id}`, body)

	delete = (companyId: id, wallboardId: id, id: id) =>
		this.doDelete(`/company/${companyId}/wallboard/${wallboardId}/queue/${id}`)
}

export default Queue
